// eslint-disable-next-line import/prefer-default-export
export enum ETab {
  LOGIN = 'login',
  REGISTRATION = 'registration',
}
